package com.macrofocus.common.json

/**
 * Represents the type of the underlying JsonValue.
 */
enum class JsonType {
    OBJECT, ARRAY, STRING, NUMBER, BOOLEAN, NULL
}